export default {"src":"/_next/static/media/info.8c1d65fc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};